
import ApexCharts from 'apexcharts'
import { useEffect } from 'react'
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
interface IGraficoPontos{

  id: string
  pontosTotaisPercebidos: number
  pontosAtencaoPercebidos: number
  pontosFortesPercebidos: number
  pesquisasPontosPercebidos: number

}

export const GraficoPontos: React.FC<IGraficoPontos> = ({ id, pesquisasPontosPercebidos, pontosAtencaoPercebidos, pontosFortesPercebidos, pontosTotaisPercebidos }) => {
  function GerarGrafico(): void {
    const options = {
      series: [
        {
          name: '',
          data: [pesquisasPontosPercebidos, pontosTotaisPercebidos, pontosAtencaoPercebidos, pontosFortesPercebidos]
        }
      ],

      chart: {
        type: 'bar',

        height: 450,
        width: 405
      },
      plotOptions: {
        bar: {
          distributed: true,
          horizontal: false,
          dataLabels: {
            position: 'top'
          }
        }
      },
      // stroke: {
      //   width: 1,
      //   colors: ['#fff']
      // },
      colors: ['#386ac6', '#ae27a9', '#dcaa21', '#7310ed'],
      title: {
        text: 'Percepção pontos de atenção x fortes'
      },
      dataLabels: {
        enabled: true,
        formatter: function (val: number) {
          return val.toString()
        },
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ['#000']
        }
      },
      xaxis: {

        categories: ['Pesquisas', 'Total', 'Pontos de atenção', 'Pontos fortes']

      },
      yaxis: {
        title: {
          text: undefined
        }
      },
      tooltip: {
        y: {
          formatter: function (val: any) {
            return val
          }
        }
      },
      fill: {
        opacity: 1
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        offsetX: 40
      }
    }

    const chart = new ApexCharts(document.querySelector(`#${id ?? 'asdfafd334'}`), options)
    chart.render()
  }

  useEffect(() => {
    GerarGrafico()
  }, [pontosAtencaoPercebidos, pontosFortesPercebidos, pontosTotaisPercebidos, pesquisasPontosPercebidos])

  return (<div id={id ?? 'asdfafd334'}></div>)
}
